import { defineMessages } from 'react-intl';

export default defineMessages({
  requiredField: {
    id: 'Required field',
    defaultMessage: 'Required field'
  },
  invalidField: {
    id: 'Invalid field',
    defaultMessage: 'Invalid field'
  },
  labelEmail: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  labelPassword: {
    id: 'Password',
    defaultMessage: 'Password'
  },
  labelSignInMContigo: {
    id: 'Sign In',
    defaultMessage: 'Sign In'
  },
  labelLinkForgotPassword: {
    id: 'Have you forgotten?',
    defaultMessage: 'Have you forgotten?'
  },
  labelLinkRecoverPassword: {
    id: 'Recover password',
    defaultMessage: 'Recover password'
  },
  divider: {
    id: 'OR',
    defaultMessage: 'OR'
  },
  forgotPasswordURL: {
    id: 'forgotPasswordURL',
    defaultMessage: '/cuenta/recuperar-contrasena'
  },
});
